import { createClient } from '@supabase/supabase-js';

// Project connection details
const SUPABASE_URL = 'https://iynrcvyfmprvaolyrkcv.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml5bnJjdnlmbXBydmFvbHlya2N2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY5MjU4MzMsImV4cCI6MjA5MjUwMTgzM30.80T7103QzadZ6sRh3nFQHdBWHwlY2nanuYt91wZBxTI';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});